export default function() {
    $(document).on('click', '.edit-image-profile', function(){
        if($('[name="image-file-upload"]').hasClass('pe-none')){
            $('[name="image-file-upload"]').removeClass('pe-none');
            $(".input-image-container img").css('opacity', 0);
            $('[name="image-file-upload"]').trigger('click');
        } else {
            $('[name="image-file-upload"]').addClass('pe-none');
            $(".input-image-container img").css('opacity', 1);
        }
    });
    $(document).on('change', '[name="image-file-upload"]', function(event){
        let profile_pic = $(this).prop("files")[0];
        var fileName = URL.createObjectURL(profile_pic);
        $(".input-image-container img").attr('src', fileName);
        $(".navbar img.rounded-circle").attr('src', fileName);
        $(".input-image-container img").css('opacity', 1);
        let form_data = new FormData();
        form_data.append("profile_pic", profile_pic);
        $('.loader-container').removeClass('d-none');
        $.ajax({
            'method': 'POST',
            'url': '/ajax/save-profile-pic',
            'data': form_data,
            'contentType': false,
            'processData': false,
            success: function(response){
                $('.loader-container').addClass('d-none');
                if(response.success){
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai aggiornato con successo la tua immagine profilo!',
                        icon: 'success',
                    });
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'La tua nuova immagine profilo non è stata aggiornata correttamente, si prega di ripetere l\'operazione',
                        icon: 'error',
                    });
                }
            },
            error: function(error){
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'La tua nuova immagine profilo non è stata aggiornata correttamente, si prega di ripetere l\'operazione',
                    icon: 'error',
                });
            }
        });
    });

    $(document).on('click', '.password-container > .icon-container', function(){
        let input = $(this).parent().find('input');
        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
        } else {
            input.attr('type', 'password');
        }
    });

    $(document).on('click', '#reset-password .btn-backend', function(){
        $('.loader-container').removeClass('d-none');
        $.ajax({
            'url': '/ajax/reset-password',
            'method': 'POST',
            'data': $('#reset-password').serialize(),
            success: function(response){
                $('.loader-container').addClass('d-none');
                if(response.success){
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai aggiornato con successo la tua password!',
                        icon: 'success',
                    });
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'La tua password non è stata aggiornata correttamente, si prega di ripetere e ricontrollare i campi inseriti',
                        icon: 'error',
                    });
                }
            },
            error: function(error){
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'La tua password non è stata aggiornata correttamente, si prega di ripetere e ricontrollare i campi inseriti',
                    icon: 'error',
                });
            }
        });
    });
}